import makeStyles from '@mui/styles/makeStyles'
import React from 'react'

const useStyles: any = makeStyles(theme => ({
  blue: {
    backgroundColor: theme.palette.primary.main,
  },
  blue2: {
    backgroundColor: theme.palette.primary.light,
  },
  orange: {
    backgroundColor: theme.palette.error.main,
  },
  orange2: {
    backgroundColor: theme.palette.warning.main,
  },
}))

export const useInputDialogColor = () => {
  const classes = useStyles()

  return (orderDirection: string, isNotInfoClient: boolean) => {
    if (orderDirection === 'OD_SELL') {
      return isNotInfoClient ? classes.orange2 : classes.orange
    }
    return isNotInfoClient ? classes.blue2 : classes.blue
  }
}
